import Link from '@eversports/klimt-primitives/legacy/Link'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../../../localization/react'

const ProfileVisibilitySettingActionItem = () => {
  return (
    <Link to="/u/privacy" external>
      <Text sx={{ color: 'midnight', paddingY: 4, paddingX: 6 }}>
        <Localized id="edit-profile-privacy-call-to-action" />
      </Text>
    </Link>
  )
}

export default ProfileVisibilitySettingActionItem
